import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link, useLocation, useNavigate, NavLink} from "react-router-dom";
import {Outlet} from "react-router";
import {LOGIN, LOGOUT} from "../Actions/types";
import {useDispatch, useSelector} from "react-redux";
import jwt from 'jwt-decode'
import store from "../store";


function AccountLayout() {
    const {t} = useTranslation();
    const location = useLocation();
    const [pageLanguage, setPageLanguage] = useState(location.pathname.split('').slice(1, 3).join(''));
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const {isLoggedIn} = useSelector((state) => state.auth);
    
    
    const [userName, setUserName] = useState("");
    const [roles, setRoles] = useState([]);
    
    function logoutUser() {
        if (localStorage.getItem("user") !== null) {
            localStorage.removeItem("user");
        }
        
        store.dispatch({
            type: LOGOUT,
        });
        navigate("/" + pageLanguage)
    }
    
    
    useEffect(() => {
        if (pageLanguage !== location.pathname.split('').slice(1, 3).join('')) {
            const tempLang = location.pathname.split('');
            setPageLanguage(tempLang.slice(1, 3).join(''));
        }
        if (localStorage.getItem("user") !== null) {
            let tempObj = JSON.parse(localStorage.getItem("user"));
            setUserName(jwt(tempObj["access_token"])["FirstName"]);
            let tempRoles = jwt(tempObj["access_token"])["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
            if (tempRoles && tempRoles.length > 0) {
                setRoles(tempRoles);
            } else {
                setRoles(["User"]);
            }
        } else {
            setRoles([]);
        }
    }, [location.pathname, isLoggedIn]);
    
    return (
        <div className={`Account_page_container ${pageLanguage === 'fa' ? "font_farsi" : "font_en"}`}>
            {/*<div className="breadcrumb_container dir_ltr">*/}
            {/*    <Breadcrumb className="breadcrumb">*/}
            {/*        <Breadcrumb.Item linkAs={Link} className="breadcrumb_item" linkProps={{to: "/" + pageLanguage, className: "breadcrumb_item"}}>Home</Breadcrumb.Item>*/}
            {/*        <Breadcrumb.Item linkAs={Link} className="breadcrumb_item"*/}
            {/*                         linkProps={{to: location, className: "breadcrumb_item breadcrumb_item_current"}}>Account</Breadcrumb.Item>*/}
            {/*    </Breadcrumb>*/}
            {/*</div>*/}
            <div className="Account_layout_container">
                <div className="account_sidebar">
                    <div className="mobile_only account_sidebar_header">
                        <h2 className="hello_name">{t("Hello")} {userName}</h2>
                        <button className="account_logout" onClick={() => logoutUser()}>{t("LOG OUT")}</button>
                    </div>
                    <h2 className="hello_name desktop_only">{t("Hello")} {userName}</h2>
                    <div className="account_sidebar_list_container">
                        <ul className="account_sidebar_list">
                            <li className="account_sidebar_list_item"><NavLink end to={"/" + pageLanguage + "/Account/Projects"} className="account_sidebar_list_item_link">{t("MY PROJECTS")}</NavLink></li>
                            <li className="account_sidebar_list_item"><NavLink end to={"/" + pageLanguage + "/Account/OrderHistory"} className="account_sidebar_list_item_link">{t("ORDER HISTORY")}</NavLink></li>
                            <li className="account_sidebar_list_item"><NavLink end to={"/" + pageLanguage + "/Account/AddressBook"} className="account_sidebar_list_item_link">{t("ADDRESS BOOK")}</NavLink></li>
                            <li className="account_sidebar_list_item"><NavLink end to={"/" + pageLanguage + "/Account/Favorites"} className="account_sidebar_list_item_link">{t("FAVORITES")}</NavLink></li>
                            <li className="account_sidebar_list_item"><NavLink end to={"/" + pageLanguage + "/Account"} className="account_sidebar_list_item_link">{t("ACCOUNT SETTINGS")}</NavLink></li>
                            <li className="account_sidebar_list_item"><NavLink end to={"/" + pageLanguage + "/Account"} className="account_sidebar_list_item_link">{t("GIFT CARD")}</NavLink></li>
                            <li className="account_sidebar_list_item"><NavLink end to={"/" + pageLanguage + "/Account"} className="account_sidebar_list_item_link">{t("MY REWARDS")}</NavLink></li>
                            {roles.includes("WebsiteAdmin") && <li className="account_sidebar_list_item"><NavLink to={"/admin/panel"} className="account_sidebar_list_item_link">{t("WEBSITE PANEL")}</NavLink></li>}
                            {roles.includes("WebsiteAdmin") && <li className="account_sidebar_list_item"><NavLink to={"/admin/panel2/en"} className="account_sidebar_list_item_link">{t("WEBSITE PANEL-2")}</NavLink></li>}
                        </ul>
                    </div>
                    <button className="account_logout desktop_only" onClick={() => logoutUser()}>{t("LOG OUT")}</button>
                </div>
                <div className="account_outlet">
                    <Outlet/>
                </div>
            </div>
        </div>
    );
}

export default AccountLayout;